<template lang="html">
	<div :class='`VForm ${componentParams.template}`'>
		<!-- {{componentParams}} -->
		<bx24-discount
			v-if='componentParams.template == "bx24-discount"'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<bx24-consultation
			v-else-if='componentParams.template == "bx24-consultation"'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<bx24-demo
			v-else-if='componentParams.template == "bx24-demo"'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<bx24-buy
			v-else-if='componentParams.template == "bx24-buy"'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<project-callback
			v-else-if='componentParams.template == "project-callback"'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<header-callback
			v-else-if='componentParams.template == "header-callback"'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<buy-button
			v-else-if='componentParams.template == "buy-button"'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<popup-form
			v-else-if='componentParams.template == "popup-form"'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<contacts
			v-else-if='componentParams.template == "contacts"'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<form-product-sidebar
			v-else-if='componentParams.template == "form-product-sidebar"'
			:data='api_response'
			@SENDFORM='submit'
		/>
		<cat-callback
			v-else-if='componentParams.template == "cat-callback"'
			:data='api_response'
			@SENDFORM='submit'
		/>
		<template v-else>
			Unknown form template <b>{{componentParams.template}}</b>
		</template>
	</div>
</template>

<script>
const objectMerge = require('object-merge');

module.exports = {
	name: 'Form',

	components: {
		'bx24-discount': require('./forms/bx24-discount.vue'),
		'bx24-consultation': require('./forms/bx24-consultation.vue'),
		'bx24-demo': require('./forms/bx24-demo.vue'),
		'bx24-buy': require('./forms/bx24-buy.vue'),
		'project-callback': require('./forms/project-callback.vue'),
		'cat-callback': require('./forms/cat-callback.vue'),
		'header-callback': require('./forms/header-callback.vue'),
		'buy-button': require('./forms/buy-button.vue'),
		'popup-form': require('./forms/form-popup.vue'),
		'form-product-sidebar': require('./forms/form-product-sidebar.vue'),
		'contacts': require('./forms/contacts.vue')
	},

	props: {
		dataParams: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			api_response: {}
		}
	},

	computed: {
		componentParams() {
			let str = this.dataParams.replace(/'/g, '"');
			return JSON.parse(str);
		}
	},

	methods: {
		submit(payload) {
			// console.log(payload);

			let method = this.componentParams.method;
			let url = this.componentParams.url;
			let custom_request = objectMerge(this.componentParams.request, payload.request || {});

			let options = {
				responseType: 'json'
			}

			let requestBody = objectMerge(custom_request, payload);
			// console.log(requestBody);

			if(method.toLowerCase() == 'post') {
				// options.params = requestBody;
				// options.body = requestBody;
				options.emulateJSON = true;
				this.$http[method](url, requestBody, options).then(success).catch(error);
			}
			else if(method.toLowerCase() == 'get') {
				options.params = requestBody;
				this.$http[method](url, options).then(success).catch(error);
			}

			function success(response) {
				$.fancybox.open(response.body.api_response.message, {
					padding: 0,
					afterClose: () => {
						this.$emit('clear');
					}
				});

				setTimeout(() => {
					$.fancybox.close()
				}, 4000)
			}

			function error(err) {
				console.log(err);
			}

		}
	},


	beforeMount() {
		let method = this.componentParams.method;
		let url = this.componentParams.url;
		let custom_request = this.componentParams.request;

		let options = {
			responseType: 'json'
		}

		if(method.toLowerCase() == 'post') {
			// options.params = custom_request;
			// options.body = custom_request;
			options.emulateJSON = true;
			this.$http[method](url, custom_request, options).then(success).catch(error);
		}
		else if(method.toLowerCase() == 'get') {
			options.params = custom_request;
			this.$http[method](url, options).then(success).catch(error);
		}

		function success(response) {
			// console.log(response);
			this.api_response = response.body ? response.body.api_response : {};
		}

		function error(err) {
			console.log(err);
		}
	},

	mounted() {



		// console.log(this.dataParams);
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Form.vue?311ef00c